// extracted by mini-css-extract-plugin
export default {"label":"ni_JtgVc","borderer":"xR0BSgaW","input":"x8wiyKvl","icons":"qwVWNYvv"};